/* @flow */
import { Request } from "shared/src/services/Requests";

const RequestBuilder = new Request.Builder("customerassist", "businessaccounts");

const service = {
    getBusinessAccounts(countryCode: string, idamToken: string) {
        const template = "/accountSwitchData/country/{country}";
        const body = { token: idamToken };
        return RequestBuilder.path(template, { country: countryCode.toUpperCase() }).body(body).post();
    },
    setActiveAccount(countryCode: string, idamToken: string, activeAccountId: string) {
        const template = "/accountSwitchData/country/{country}";
        const body = { token: idamToken, activeAccountId: activeAccountId };
        return RequestBuilder.path(template, { country: countryCode.toUpperCase() }).body(body).put();
    }
};

export default service;

export const { getBusinessAccounts, setActiveAccount } = service;
